// The edit modal used to `delete payload.description` / `delete payload.system_prompt` when the field was
// empty, so the key never reached the PATCH (which applies only the keys it receives): an admin who
// emptied the description or system prompt saw "saved" while the old value stayed. An emptied optional
// text field is now sent as null, which clears it (and is a no-op when it was already empty).
//
// EMPLOYEE-IDENTITY-PERSONA-001: the persona text fields follow the same rule, and specialties are
// typed as one comma-separated line in the editor but stored as a list.
// description / system_prompt are ALWAYS sent (null when empty or absent) — that is the existing
// PATCH contract. The persona fields are only normalised when the form carries them, so a caller
// that never showed the persona editor cannot accidentally wipe an employee's identity.
const ALWAYS_TEXT = ["description", "system_prompt"];
const PERSONA_TEXT = ["role_title", "avatar_key", "personality", "intro_text"];

export function parseSpecialties(text) {
  return String(text || "")
    .split(/[,\n]/)
    .map((s) => s.trim())
    .filter(Boolean)
    .slice(0, 20);
}

export function buildAgentUpdatePayload(form) {
  const payload = { ...form };
  for (const key of ALWAYS_TEXT) payload[key] = payload[key] || null;
  for (const key of PERSONA_TEXT) {
    if (key in payload) payload[key] = payload[key] || null;
  }
  if ("specialties_text" in payload) {
    payload.specialties = parseSpecialties(payload.specialties_text);
    delete payload.specialties_text;
  }
  if ("avatar_color" in payload && !payload.avatar_color) payload.avatar_color = null;
  return payload;
}
